module.exports = __webpack_public_path__ + "static/media/Acoustic (Acoustic Sim V2) VR.37aa1e4.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/amp/Acoustic (Acoustic Sim V2) VR.mp3
// module id = sexL
// module chunks = 13